/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { configSelector } from 'Selectors/config';
import { connect } from 'react-redux';
import css from './ReservationIconBtn.scss';
import { fileNames } from 'Constants/imageUrls';
import withConfig from 'HOCs/withConfig/withConfig';
import PropTypes from 'prop-types';
import Button from 'Components/Button/Button';
import { isMobile } from 'Helpers/devices';
import { FormattedMessage as Translation } from 'react-intl';
import classNames from 'classnames';
import { compose } from 'redux';
import withVwo from 'HOCs/withVwo/withVwo';

const ReservationIconBtn = props => {
    const {
        config,
        disabledButton,
        showBtnLabel = true,
        btnType = 'primary',
        isPrimary = true,
        vwoClientInstance,
        escrowAdpCtaExperiment
    } = props;
    const staticAssestUrl = config.get('staticAssets');
    const [imageSrc, setImageSrc] = useState(disabledButton ? `${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON_DISABLED}` : `${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON}`);
    const translations = {
        booking: <Translation id="booking" defaultMessage="Booking" />,
        alreadyBooked: <Translation id="alreadyBookedItem" defaultMessage="Sudah Dibooking" />,
        safeBuy: <Translation id="safeBuy" defaultMessage="Beli aman" />,
        safePay: <Translation id="safePay" defaultMessage="Bayar aman" />
    };

    const handleMouseOver = () => {
        if (!isMobile && !disabledButton) {
            setImageSrc(`${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON_ACTIVE}`);
        }
    };

    const handleMouseOut = () => {
        if (!isMobile && !disabledButton) {
            setImageSrc(`${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON}`);
        }
    };

    useEffect(() => {
        if (disabledButton) {
            setImageSrc(`${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON_DISABLED}`);
        }
        else if (isMobile && !isPrimary) {
            setImageSrc(`${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON_ACTIVE}`);
        }
        else if (isMobile && isPrimary) {
            setImageSrc(`${staticAssestUrl}${fileNames.BOOKING_ITEM_ICON}`);
        }
    }, [isMobile, isPrimary, disabledButton]);

    const vwoEscrowExperiment = () => {
        const isOlxMobbi = config.get('isOlxMobbi');

        if (escrowAdpCtaExperiment?.enabled) {
            const deviceType = isMobile ? 'web-mobile' : 'web-desktop';
            const variantType = isOlxMobbi ? 'ctx' : 'cla';

            const experimentStatus = escrowAdpCtaExperiment.data[`${deviceType}_${variantType}`];

            if (experimentStatus !== 'concluded') {
                const experimentKey = isMobile ? 'mobile_escrow_booking_cta_label' : 'desktop_escrow_booking_cta_label';
                const label = vwoClientInstance.getVariationName(experimentKey);

                if (label === 'ADP-CTA-Booking') {
                    return translations.booking;
                }
                else if (label === 'ADP-CTA-Beli-Aman') {
                    return translations.safeBuy;
                }
                else if (label === 'ADP-CTA-Bayar-Aman') {
                    return translations.safePay;
                }
            }
        }
        return translations.booking;
    };

    return (
        <div
            onMouseOver={ handleMouseOver }
            onMouseOut={ handleMouseOut }
        >
            <Button
                type={ btnType }
                className={ classNames(css.reservationButton, { [css.reservationButtonMobile]: isMobile }) }
                data-aut-id="reservasiBtn"
                disabled={ disabledButton }
            >
                <img src={ imageSrc } alt="Reservation Icon" />
                { showBtnLabel
            && <span className={ css.text }>
                {disabledButton ? translations.alreadyBooked : vwoEscrowExperiment()}
            </span>
                }
            </Button>
        </div>
    );
};

ReservationIconBtn.propTypes = {
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    disabledButton: PropTypes.bool,
    showBtnLabel: PropTypes.bool,
    btnType: PropTypes.string,
    isPrimary: PropTypes.bool,
    vwoClientInstance: PropTypes.object,
    escrowAdpCtaExperiment: PropTypes.object
};

export const mapStateToProps = state => {
    return {
        escrowAdpCtaExperiment: configSelector(state)?.features?.find(feature => feature.name === 'escrow_adp_cta_experimentation')
    };
};

export default compose(
    withConfig,
    withVwo,
    connect(mapStateToProps)
)(ReservationIconBtn);
